import React, { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { Avatar, AvatarFallback, AvatarImage } from "./ui/avatar"
import { Button } from "./ui/button"
import { User, Settings, LogOut } from "lucide-react"

interface UserDropdownProps {
  user: any
  className?: string
}

export default function UserDropdown({ user, className = "" }: UserDropdownProps) {
  const navigate = useNavigate()
  const { logout } = useAuth()
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsDropdownOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const handleLogout = () => {
    setIsDropdownOpen(false)
    logout()
    navigate('/')
  }

  const getUserInitials = (fullName: string) => {
    return fullName
      .split(' ')
      .map(name => name.charAt(0))
      .join('')
      .toUpperCase()
      .slice(0, 2)
  }

  return (
    <div className={`user-menu-wrapper dropdown-container ${className}`} ref={dropdownRef}>
      <Button
        variant="ghost"
        className="relative h-8 w-8 rounded-full hover:bg-emerald-50"
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
      >
        <Avatar className="h-8 w-8 border-2 border-emerald-200">
          <AvatarFallback className="bg-emerald-100 text-emerald-700">
            {user ? getUserInitials(user.full_name) : 'U'}
          </AvatarFallback>
        </Avatar>
      </Button>

      {isDropdownOpen && (
        <div 
          className="user-dropdown global-dropdown"
          style={{ 
            position: 'absolute',
            top: '100%',
            right: 0,
            zIndex: 9999,
            marginTop: '8px'
          }}
        >
          <div className="px-4 py-3 border-b border-gray-200">
            <p className="text-sm font-medium text-gray-900">
              {user ? user.full_name : 'Nežinomas vartotojas'}
            </p>
            <p className="text-xs text-gray-500">
              {user ? user.email : ''}
            </p>
          </div>
          
          <div className="py-1">
            <div className="flex items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-emerald-50 cursor-pointer">
              <User className="w-4 h-4" />
              <span>Profilis</span>
            </div>
            <div className="flex items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-emerald-50 cursor-pointer">
              <Settings className="w-4 h-4" />
              <span>Nustatymai</span>
            </div>
          </div>
          
          <div className="border-t border-gray-200 py-1">
            <div 
              className="flex items-center gap-3 px-4 py-2 text-sm text-red-600 hover:bg-red-50 cursor-pointer"
              onClick={handleLogout}
            >
              <LogOut className="w-4 h-4" />
              <span>Atsijungti</span>
            </div>
          </div>
        </div>
      )}
    </div>
  )
} 